import React, { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Cloud8 from "../../../Img/clouds8.png";
import AOS from "aos";

import img1 from "../../../Img/service-icons/web-dev/php.svg";
import img2 from "../../../Img/service-icons/web-dev/sql.svg";
import img3 from "../../../Img/service-icons/web-dev/react.svg";
export default function WebAppDev() {
  useEffect(() => {
    AOS.init({
      once: true,
      offset: 120,
    });
  }, []);
  const webAppData = [
    {
      id: 1,
      Img: img1,
      Title: "PHP development",
      Text: "PHP is primarily used for server-side scripting to handle the dynamic content of websites. Its main applications in web development include: Generating dynamic page content: PHP can create dynamic web pages and interact with databases to provide personalized content to users.",
    },
    {
      id: 2,
      Img: img2,
      Title: "MySQL",
      Text: "MySQL is a robust relational database management system that seamlessly integrates with PHP, forming a formidable duo for web development projects. This partnership allows developers to create dynamic content by efficiently storing and retrieving data from databases.",
    },
    {
      id: 3,
      Img: img3,
      Title: "React development",
      Text: "React. js is an open-source JavaScript library, crafted with precision by Facebook, that aims to simplify the intricate process of building interactive user interfaces. Imagine a user interface built with React as a collection of components, each responsible for outputting a small, reusable piece of HTML code.",
    },
  ];

  return (
    <>
      <section className="section-padding">
        <Container>
          <Row className="mb-5">
            <div className="col-lg-12">
              <div
                className="sec-title"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="500"
              >
                <img className="cloud" src={Cloud8} alt="cloud" />
                <h2>
                  <span>Web application development services</span>
                </h2>
              </div>
            </div>
          </Row>
          <Row className="g-5">
            {webAppData.map((webAppData) => (
              <div
                className="col-lg-4 col-md-6 col-sm-12 col-xs-12"
                key={webAppData.id}
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="500"
              >
                <div className="crumina-module crumina-info-box info-box--standard-hover">
                  <div className="info-box-image">
                    <img
                      className="utouch-icon img-fluid"
                      alt="Services"
                      src={webAppData.Img}
                    />
                  </div>
                  <div className="info-box-content">
                    <h5 className="info-box-title">{webAppData.Title}</h5>
                    <p className="info-box-text">{webAppData.Text}</p>
                  </div>
                </div>
              </div>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
}
